import React from 'react'
import i18next from 'i18next'
import { useTranslation } from 'react-i18next'
import { DataListItem } from '@node-space/ui-components'

interface ConvertOutProps {
  amountWithCurrency: string
  currencyFrom: string
  currencyTo: string
  convertedFromWallet: string
  convertedToWallet: string
  exchangeRate: number
  convertedAmountTo?: string
}

const ConvertOut = ({
  amountWithCurrency,
  currencyFrom,
  currencyTo,
  convertedFromWallet,
  convertedToWallet,
  exchangeRate,
  convertedAmountTo,
}: ConvertOutProps) => {
  const { t } = useTranslation()
  return (
    <>
      {amountWithCurrency && (
        <DataListItem
          id="amount-converted"
          testId="amount-converted"
          title={i18next.t('transactions.sideBar.amountConverted')}
          body={amountWithCurrency}
        />
      )}
      {convertedFromWallet && (
        <DataListItem
          id="converted-from"
          testId="converted-from"
          title={i18next.t('transactions.sideBar.convertedFrom')}
          body={convertedFromWallet}
        />
      )}
      {convertedToWallet && (
        <DataListItem
          id="converted-to"
          testId="converted-to"
          title={i18next.t('transactions.sideBar.convertedTo')}
          body={convertedToWallet}
        />
      )}
      {convertedAmountTo && (
        <DataListItem
          id="converted-amount-to"
          testId="converted-amount-to"
          title={t('wallets.searchTransaction.payOutAmount')}
          body={convertedAmountTo}
        />
      )}
      {exchangeRate && (
        <DataListItem
          id="exchange-rate"
          testId="exchange-rate"
          title={t('wallets.searchTransaction.exchangeRate')}
          body={`1 ${currencyFrom} = ${exchangeRate} ${currencyTo}`}
        />
      )}
    </>
  )
}

export default ConvertOut
